export const userEventNames = {
    KWF_OPEN_IN_SCH: 'kwf_open_in_sch',
    KWF_TRACK_IN_SW: 'kwf_track_in_sw',
};
